module.exports = __webpack_public_path__ + "static/media/hps.b45b53d3.png";